import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Buildings20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.5557 7.41669H15.0001V5.91669H10.5557V7.41669Z'
      fill='currentColor'
    />
    <path d='M15.0001 10.75H10.5557V9.25H15.0001V10.75Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.33339 7.02778H7.58339V2.77778C7.58339 2.06669 8.17785 1.47223 8.88894 1.47223H16.6667C17.3778 1.47223 17.9723 2.06669 17.9723 2.77778V17.7778C17.9723 18.192 17.6365 18.5278 17.2223 18.5278H2.77783C2.36362 18.5278 2.02783 18.192 2.02783 17.7778V8.33334C2.02783 7.62225 2.62229 7.02778 3.33339 7.02778ZM9.08339 17.0278V2.97223H16.4723V17.0278H13.5278V14.4445H12.0278V17.0278H9.08339ZM7.58339 8.52778V17.0278H3.52783V8.52778H7.58339Z'
      fill='currentColor'
    />
  </Svg>
);

Buildings20.displayName = 'Buildings20';
export default Buildings20;
